var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-dialogPage"},[(!_vm.$route.query.sel || _vm.$route.query.sel === 'all' || !_vm.mobileState)?_c('cmp-list'):_vm._e(),_vm._v(" "),((_vm.$route.query.sel && _vm.$route.query.sel !== 'all') || !_vm.mobileState)?_c('cmp-message'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e9dae0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue_components/Dialog/Index.vue
// module id = 382
// module chunks = 0